import React, { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react'
import { Modal, Button, Tabs, Tab } from 'react-bootstrap';
import SaveButton from 'components/misc/Button';
import Loader from 'components/misc/Loader';
import Home from './Home';
import Accounts from './Accounts';
import Related from './Related';
import Notes from './Notes';

import SendMail from 'components/pages/invoices/partials/SendMail';
import Note from 'components/partials/notes/AddOrEdit';

import Question from 'components/modals/Question';
import Info from 'components/modals/Info';

import Api from 'helpers/Api';

import { MODELS } from 'constants/models';
import Refs from 'Refs';
import LinkAccount from '../partials/LinkAccount';
import { useAppContext } from 'providers/App';
import { useAuthDataContext } from 'providers/Auth';
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';

function View(props, ref) {

    const tabs = [
        {
            id: 'home',
            name: 'Преглед',
            component: Home
        },
        {
            id: 'accounts',
            name: 'Свързани сметки',
            component: Accounts
        },
        {
            id: 'documents',
            name: 'Свързани документи',
            component: Related
        },
        {
            id: 'notes',
            name: 'Бележки',
            component: Notes
        },
    ];

    const app = useAppContext();
    const auth = useAuthDataContext();

    const [state, setState] = useState({
        show: false,
        params: null,
        id: null,
        tabId: tabs[0].id,
        key: 1,
        onClose: null,
    });

    const sendMailModalRef = useRef(null);
    const noteModalRef = useRef(null);
    const questionModalRef = useRef(null);
    const infoModalRef = useRef(null);
    const linkAccountModalRef = useRef(null);
    const leftArrowRef = useRef(null);
    const rightArrowRef = useRef(null);

    useImperativeHandle(ref, () => ({
        open: (id, resetTab = true) => {
            handleShow(id, resetTab);
        },
        close: () => {
            handleClose();
        },
        onClose: fn => {
            setState(prev => ({
                ...prev,
                onClose: fn
            }));
        }
    }));

    const show = (onEntering = null) => {
        setState(prev => ({
            ...prev,
            show: true,
            onEntering: onEntering,
        }));
    }

    const hide = (onExiting = null) => {
        setState(prev => ({
            ...prev,
            show: false,
            onExiting: onExiting
        }));
    }

    const handleShow = (id, resetTab = true) => {
        setState(prev => ({
            ...prev,
            id: id,
            tabId: resetTab || !prev.tabId ? getDefaultActiveTab()?.id : prev.tabId,
        }));

        show();
    }

    const handleClose = () => {
        setState(prev => ({
            ...prev,
            show: false,
            tabId: tabs[0].id
        }));

        if (typeof state.onClose === 'function') {
            hide(state.onClose);
        } else {
            hide();
        }

        setState(prev => ({
            ...prev,
            onClose: null,
        }));
    }

    const setKey = id => {
        setState(prev => ({
            ...prev,
            tabId: id,
        }));
    }

    const refresh = () => {
        setState(prev => ({
            ...prev,
            key: new Date().getTime(),
        }));
    }

    const hasTabPermission = key => {
        let map = {
            accounts: 'invoices_accounts',
            notes: 'invoices_notes',
        };

        let permission = map[key];

        if (permission && auth.getUser().permission(permission) === false) {
            return false;
        }

        return true;
    }

    const getDefaultActiveTab = () => {
        return tabs.find(tab => {
            return hasTabPermission(tab.id);
        });
    }

    const showClient = id => {
        if (!id) {
            return;
        }

        let modal = Refs.getInstance().getRef('client');

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open(id);
        });

        modal.onClose(() => {
            show();
        });
    }

    const sendMail = data => {
        if (!data) {
            return;
        }

        let modal = sendMailModalRef.current;

        if (!modal) {
            return;
        }

        hide(() => {
            modal.show(data.id, data.client_email);
        });

        modal.onClose(() => {
            show();
        });
    }

    const addNote = () => {

        let modal = noteModalRef.current;

        if (!modal) {
            return;
        }

        hide(() => {
            modal.add(state.id, MODELS.INVOICE);
        });

        modal.onClose(() => {
            show();
        });
    }

    const editNote = (id) => {

        let modal = noteModalRef.current;

        if (!modal) {
            return;
        }

        hide(() => {
            modal.edit(id);
        });

        modal.onClose(() => {
            show();
        });
    }

    const deleteNote = (id) => {

        let modal = questionModalRef.current;

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open('Сигурни ли сте, че искате да изтриете тази бележка?');
        });

        modal.onCancel(() => {
            show();
        });

        modal.onSuccess(() => {
            destroyNote(id, () => {
                show();
            });
        });
    }

    const destroyNote = (id, cb) => {
        Api.post('notes/delete', {
            id: id
        }).then(res => {
            cb();
        });
    }

    const showAccount = (id) => {
        let modal = Refs.getInstance().getRef('account');

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open(id);
        });

        modal.onClose(() => {
            show();
        });

    }

    const deleteAccount = (id) => {

        let modal = questionModalRef.current;

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open('Сигурни ли сте, че искате да премахнете връзката между избрания документ и тази сметка?');
        });

        modal.onCancel(() => {
            show();
        });

        modal.onSuccess(() => {
            unlinkAccount(id, () => {
                show();
            });
        });
    }

    const unlinkAccount = (id, cb) => {
        Api.post('accounts/unlink-invoice', {
            id: id,
            invoice_id: state.id,
        }).finally(res => {
            cb();
        });
    }

    const linkAccount = (cb) => {
        let modal = linkAccountModalRef.current;

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open(state.id);
        });

        modal.onClose(() => {
            show();
        });

        modal.onSuccess(() => {
            if (typeof cb === 'function') {
                cb();
            }
        });
    }

    const showInvoice = (id) => {
        let modal = Refs.getInstance().getRef('invoice');

        if (!modal) {
            return;
        }

        hide(() => {
            modal.open(id);
        });

        modal.onClose(() => {
            show();
        });

    }

    useEffect(() => {
        if (!state.show) {
            return;
        }

        const onKeyPress = (e) => {
            if (e.key === 'ArrowRight') {
                rightArrowRef.current?.click();
            }

            if (e.key === 'ArrowLeft') {
                leftArrowRef.current?.click();
            }
        }

        window.addEventListener('keyup', onKeyPress);

        return () => {
            window.removeEventListener('keyup', onKeyPress);
        }
    }, [state.show]);

    const handleShowNextItem = e => {
        e.preventDefault();

        if (props.showNextItem) {
            props.showNextItem(state.id);
        }
    }

    const handleShowPrevItem = e => {
        e.preventDefault();

        if (props.showPrevItem) {
            props.showPrevItem(state.id);
        }
    }

    const handleRefresh = e => {
        e.preventDefault();

        refresh();
    }

    return (
        <>
            <SendMail
                ref={sendMailModalRef}
            />

            <Note
                ref={noteModalRef}
            />

            <LinkAccount
                ref={linkAccountModalRef}
            />

            <Question
                ref={questionModalRef}
            />

            <Info
                ref={infoModalRef}
                showCancel
            />

            <Modal size="xl" centered show={state.show} onHide={handleClose} onEntering={state.onEntering} onExiting={state.onExiting}>
                {props.showPrevItem &&
                    <span ref={leftArrowRef} className="arrow left" onClick={handleShowPrevItem}>
                        <ChevronLeft />
                    </span>
                }
                {props.showNextItem &&
                    <span ref={rightArrowRef} className="arrow right" onClick={handleShowNextItem}>
                        <ChevronRight />
                    </span>
                }
                <Modal.Header>
                    <Modal.Title>
                        Преглед на документ
                    </Modal.Title>
                    <div className="buttons">
                        <button className="btn-reload" onClick={handleRefresh}>

                        </button>
                        <button className="btn-close" onClick={handleClose}>

                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Tabs
                        key={state.key}
                        activeKey={state.tabId}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                        mountOnEnter
                    >
                        {tabs.map(tab =>
                            <Tab key={tab.id} eventKey={tab.id} title={tab.name} disabled={hasTabPermission(tab.id) === false}>
                                {React.createElement(tab.component, {
                                    id: state.id,
                                    show: show,
                                    hide: hide,
                                    showClient: showClient,
                                    sendMail: sendMail,
                                    showAccount: showAccount,
                                    deleteAccount: deleteAccount,
                                    linkAccount: linkAccount,
                                    addNote: addNote,
                                    editNote: editNote,
                                    deleteNote: deleteNote,
                                    showInvoice: showInvoice,
                                })}
                            </Tab>
                        )}
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Затвори
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    )
}

export default forwardRef(View);